import { useEffect, useState } from "react";
import { DashboardTitle } from "../../components/DashboardTitle";
import { toast } from "react-toastify";
import { Field, Form, Formik, FormikHelpers } from "formik";
import { Skeleton, TextField } from "@mui/material";
import { BlackButton } from "../../components/black-button";
import { countries, states } from "../../constants";
import { FaShoppingCart } from "react-icons/fa";
import { environment } from "../../environments/environment";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { IAppState } from "../../store/store";
import { showCurrency } from "../../utility/currencyView";
import { useNavigate, useParams } from "react-router-dom";
import { ProductSummary } from "../../components/product-summary";

const initialValues = {
  first_name: "",
  last_name: "",
  middle_name: "",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  zip: "",
  country: "Ghana",
  phone: "",
  email: "",
};

interface ProductImage {
  media_url: string;
  uuid: string;
}

interface ProductDetails {
  product: {
    uuid: string;
    product_title: string;
    friends_price: number;
    friends_price_ngn: number;
    friends_price_zar: number;
    minimum_quantity: number;
    size_kg: string;
  };
  product_images: ProductImage[];
}



export const FriendsCheckout = () => {
  const {uuid, itemCount} = useParams<{uuid:string, itemCount:string}>()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [productDetails, setProductDetails] = useState<ProductDetails | null>(null);
  const currencyView = useSelector((state: IAppState) => 
        showCurrency(state.shared.currency)
      );

  const fetchProductDetails = async (uuid: string) => {
    try {
      const response = await api.get(
        `${environment.baseUrl}/product/fetch/single/${uuid}`
      );
      setProductDetails(response.data.data);
    }
    catch (error) {
      console.error("Error fetching product details:", error);
      return null;
    }
  };

  const handleSubmit = async (
          values: any,
          { setSubmitting }: FormikHelpers<any>
        ) => {
          // console.log(values);
          setSubmitting(false);
    
          const orderPayload = {
            ...values,
            product_uuid: uuid,
            currency: currencyView === "GH₵" ? "GHS" : currencyView === "ZAR" ? "ZAR" : "NGN",
            quantity: Number(itemCount),
            size_kg: productDetails?.product?.size_kg || "", 
            // cart_uuid: cart_uuid,
          };

          // console.log(orderPayload)
    
          try {
            setIsLoading(true)
            const response = await api.post(
              `${environment.baseUrl}/product/order/buy-friends`, orderPayload)

    
            // console.log(response.data.data);
            const checkoutLink = response.data.data.payment_link;
            // navigate(checkoutLink);
            // Open the checkout link in a new tab
            window.open(checkoutLink, '_blank');
    
            localStorage.removeItem("cart_uuid");
          } catch (error) {
            console.error(error)
          } finally {
            setIsLoading(false)
          }
        }

  useEffect(() => {
    fetchProductDetails(uuid!)
  }, [uuid])

  const isLoggedIn = useSelector((state: IAppState) => state.auth.token);
  
    useEffect(() => {
      // If user is not logged in, redirect to login page
      if (!isLoggedIn) {
        toast.error("Please log in to continue with checkout");
        navigate("/login");
      }
    }, [isLoggedIn, navigate]);



  return (
    <section className={`web_padding_x web_padding_y !pt-5`}>
       {
              isLoading && (
                <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 backdrop-blur-sm z-50 flex items-center justify-center transition-all duration-300">
                  <div className="bg-white p-8 rounded-2xl shadow-2xl border border-gray-100 w-80 flex flex-col items-center">
                    <div className="bg-gray-50 p-4 rounded-full mb-4 relative">
                      <FaShoppingCart className="text-4xl text-black opacity-20" />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="h-12 w-12 rounded-full border-4 border-t-black border-r-gray-300 border-b-gray-300 border-l-gray-300 animate-spin"></div>
                      </div>
                    </div>
                    <h3 className="font-bold text-xl mb-1">Processing Order</h3>
                    <p className="text-gray-600 text-center">Please wait while we prepare your order...</p>
                    <div className="w-full mt-4 bg-gray-100 h-1.5 rounded-full overflow-hidden">
                      <div className="h-full bg-black animate-pulse rounded-full"></div>
                    </div>
                  </div>
                </div>
              )
      }
      <DashboardTitle
                  text={"Order Details"}
      ></DashboardTitle>
      
      <div className="grid md:grid-cols-12 gap-8 mt-8">
              {/* Form Section */}
              <div className="md:col-span-8">

                {/* Product details here */}
                <Formik
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                >
                  {({ isValid, isSubmitting }) => (
                    <Form>
                      <div className="dashboard_subtitle md:mt-0">
                        Your Order Information
                      </div>
          
                      {/* ...existing form fields... */}
                      <div className="grid gap-5 mt-4 md:grid-cols-2 xl:grid-cols-3">
                        <div className="">
                          <h6 className="font-bold text-sm md:text-base">First Name</h6>
                          <Field
                            name="first_name"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="First Name...."
                          />
                        </div>
                        <div className="">
                          <h6 className="font-bold text-sm md:text-base">Middle Name <small> (optional)</small> </h6>
                          <Field
                            name="middle_name"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="Middle Name...."
                          />
                        </div>
                        <div className="">
                          <h6 className="font-bold text-sm md:text-base">Last Name </h6>
                          <Field
                            name="last_name"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="Last Name...."
                          />
                        </div>
                      </div>
          
          
                      <div className="grid gap-5 mt-4 md:grid-cols-2 xl:grid-cols-3">
                      <div className="">
                          <h6 className="font-bold text-sm md:text-base">Phone </h6>
                          <Field
                            name="phone"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="Phone Number...."
                          />
                        </div>
                      <div className="">
                          <h6 className="font-bold text-sm md:text-base">Email </h6>
                          <Field
                            name="email"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="Email...."
                          />
                        </div>
                        <div className="">
                          <h6 className="font-bold text-sm md:text-base">Address</h6>
                          <Field
                            name="address"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="Street address"
                          />
                        </div>
                        {/* <div className="">
                          <h6 className="font-bold text-sm md:text-base">Address Line 2</h6>
                          <Field
                            name="address_line2"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="(optional)"
                          />
                        </div> */}
                        <div className="">
                          <h6 className="font-bold text-sm md:text-base">City</h6>
                          <Field
                            name="city"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="City"
                          />
                        </div>
                        <div className="">
                          <h6 className="font-bold text-sm md:text-base">Country</h6>
                          <Field
                            name="country"
                            as="select"
                            className="rounded-full py-2 w-full border mt-3 pl-3"
                            // classNamePrefix="custom_select"
                          >
                            {countries.map((country, index )=> (
                              <option key={index} value={country}>{country}</option>
                            ))}
                          </Field>
                        </div>
                        {/* <div className="">
                          <h6 className="font-bold text-sm md:text-base">State</h6>
                          <Field
                            name="state"
                            as="select"
                            className="rounded-full py-2 w-full border mt-3 pl-3"
                            // classNamePrefix="custom_select"
                          >
                            <option value="">Select State</option>
                            {states.map((state, index) => (
                              <option key={index} value={state}>{state}</option>
                            ))}
                          </Field>
                        </div> */}
                        <div className="">
                          <h6 className="font-bold text-sm md:text-base">ZIP/Postal Code</h6>
                          <Field
                            name="zip"
                            as={TextField}
                            className="admin_input_1 block_input"
                            placeholder="ZIP Code"
                          />
                        </div>
                        
                        
                      </div>
          
                      <div className="mt-5 w-full max-w-[300px] flex flex-col">
                        <BlackButton
                          text="Proceed to Payment"
                          type="submit"
                          isDisabled={!isValid}
                          isLoading={isSubmitting}
                        ></BlackButton>
                      </div>
                    </Form>
                  )}
                </Formik>
        </div>

        {/* Product Summary Section */}
              <ProductSummary uuid={uuid!} itemCount={itemCount!} />
        </div>
        
    </section>
  )

}